module.exports = __webpack_public_path__ + "assets/img/tx101st.c3097440.jpg";